import squircle from '../elements/squircle.js';
squircle.register();
